import { createService } from '@betty/toolkit/api';
import {
  InteracDepositSchema,
  InteracWithdrawalSchema,
} from './PaymentLaunchService.schemas';

export default createService(
  {
    depositInterac: {
      method: 'POST',
      url: '/deposit',
      responseSchema: InteracDepositSchema,
    },
    withdrawalInterac: {
      method: 'POST',
      url: '/withdrawal',
      responseSchema: InteracWithdrawalSchema,
    },
  },
  ({ userId }) => `/paymentLaunch/${userId}/gigadat`,
);
